export function isKeySystemPlayReady(e){return!!e&&!!e.match(/^com\.(microsoft|chromecast)\.playready/)}